import { Loader } from './SmallLoader.styled';

const SmallLoader = () => {
  return <Loader />;
};

export default SmallLoader;
